// reducers/kitchen/kitchenReducer.js
import {
  FETCH_KITCHEN_ORDERS_REQUEST,
  FETCH_KITCHEN_ORDERS_SUCCESS,
  FETCH_KITCHEN_ORDERS_FAILURE,
} from "./kitchenActionTypes";

const initialState = {
  loading: false,
  orders: [],
  error: null,
};

const kitchenReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KITCHEN_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_KITCHEN_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload,
        error: null,
      };

    case FETCH_KITCHEN_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        orders: [],
      };

    default:
      return state;
  }
};

export default kitchenReducer;